import { render } from "./OrderBackDetails.vue?vue&type=template&id=2687b444&scoped=true"
import script from "./OrderBackDetails.vue?vue&type=script&lang=js"
export * from "./OrderBackDetails.vue?vue&type=script&lang=js"

import "./OrderBackDetails.vue?vue&type=style&index=0&id=2687b444&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2687b444"]])

export default __exports__